module.exports = __webpack_public_path__ + "static/media/metropolis-extra-light.c5ae0939.otf";